/**
 * client/src/lib/webauthn-credential-invalidation.ts
 *
 * Single source of truth for "the account's WebAuthn credential set changed
 * (added or revoked), refresh everything derived from it" — mirrors
 * member-lifecycle-invalidation.ts's pattern. Any mutation that adds or
 * revokes a credential must invalidate BOTH `webauthn/credentials` (the
 * Security Centre list) and `security/posture` (`hardwareKeyPresent` —
 * AalGatePanel's "Certified key on file" state, PostureImpactPanel) — the two
 * previously drifted independently at each call site.
 */
import type { QueryClient } from "@tanstack/react-query";

export function invalidateHardwareKeyState(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: ["webauthn/credentials"] });
  void queryClient.invalidateQueries({ queryKey: ["security/posture"] });
}
